module.exports = __webpack_public_path__ + "static/media/register.b57e38ce.jpeg";